module.exports = __webpack_public_path__ + "static/img/template_1.7d06bd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/template_1.jpg
// module id = dx6X
// module chunks = 92